import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import * as React from "react";
import { useState } from "react";
import { BeatLoader } from "react-spinners";
import { toast } from "sonner";
import axiosInstance from "../Axios";
import useAuth from "../contexts/UserContext.tsx";

export default function EditSchoolDialog({
  open,
  setEditSchoolDialogOpen,
  schoolDetails,
  setReload,
}) {
  const [schoolName, setSchoolName] = useState(schoolDetails.schoolName);
  const [hmName, setHmName] = useState(schoolDetails.hmName);
  const [hmPhone, setHmPhone] = useState(schoolDetails.hmPhone);
  const [address, setAddress] = useState(schoolDetails.address);
  const [loading, setLoading] = useState(false);
  useAuth();

  const clearStates = () => {
    setSchoolName(schoolDetails.schoolName);
    setHmName(schoolDetails.hmName);
    setHmPhone(schoolDetails.hmPhone);
    setAddress("");
  };

  const handleEditSchool = () => {
    const data = {
      school_id: schoolDetails.school_id,
      school_name: schoolName,
      hm_name: hmName,
      hm_phone: hmPhone,
      address1: address,
      address2: "",
    };
    setLoading(true);
    axiosInstance
      .post("updateSchoolInfo", data)
      .then(() => {
        toast.success("School Updated");
        setReload((prev) => !prev);
        setEditSchoolDialogOpen(false);
      })
      .catch((err) => {
        console.error(err.message);
        toast.error("Error updating school");
      })
      .finally(() => {
        setLoading(false);
      });
  };
  return (
    <div>
      <Dialog
        open={open}
        onClose={() => {
          clearStates();
          setEditSchoolDialogOpen(false);
        }}
        fullWidth
      >
        <DialogTitle className="opacity-95">
          Edit School
          <div className="text-sm opacity-60">Edit school details</div>
        </DialogTitle>
        <DialogContent
          sx={{ display: "flex", gap: 1, flexDirection: "column" }}
        >
          <TextField
            autoFocus
            margin="dense"
            id="school_name"
            label="School Name"
            variant="outlined"
            value={schoolName}
            onChange={(event) => setSchoolName(event.target.value)}
            size="small"
          />
          <TextField
            autoFocus
            margin="dense"
            id="hm_name"
            label="HM Name"
            variant="outlined"
            value={hmName}
            onChange={(event) => setHmName(event.target.value)}
            size="small"
          />
          <TextField
            autoFocus
            margin="dense"
            id="hm_phone"
            label="HM Phone"
            variant="outlined"
            value={hmPhone}
            onChange={(event) => setHmPhone(event.target.value)}
            size="small"
          />
          <TextField
            autoFocus
            margin="dense"
            id="address"
            label="Address"
            variant="outlined"
            value={address}
            onChange={(event) => setAddress(event.target.value)}
            size="small"
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              clearStates();
              setEditSchoolDialogOpen(false);
            }}
            color="error"
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleEditSchool}
            disabled={loading}
          >
            {loading ? (
              <BeatLoader color="#3B82F6" size={6} className="py-2 px-3" />
            ) : (
              "Submit"
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
